import React, { Ref, useEffect } from 'react';
import {
  Button,
  Col,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Slider,
  Switch,
  Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { settingPanelProps } from '../../types/type';
import SatelliteList from '../left/satelliteList/index';

const { Option } = Select;

const SettingPanel: React.FC<settingPanelProps> = (props) => {
  const { setting, setSetting, satelliteList, setSatelliteList, setScanes} = props;
  const openNotification = (message:string) => {
    notification.open({
      message: 'Notification',
      description: message
    });
  };
  const sceneNameRef = React.useRef<string>('');
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Row gutter={12}>
        <Col span={10}>
          <header className='sceneEditTitle'>Satellite Loading</header>
          <SatelliteList  satelliteList={satelliteList} setSatelliteList={setSatelliteList}/>
        </Col>
        <Col span={14}>
          <header className='sceneEditTitle'>Scene Configuration</header>
          <div className='scenceSetting'>
            <div>
              <p
                style={{
                  fontSize: '16px',
                  color: '#017efc',
                  borderBottom: '2px solid #017efc',
                }}
              >
                Basic Settings
              </p>
              <ul className='settingList'>
                <li>
                  <header
                    style={{
                      marginRight: '20px',
                      marginBottom: '20px',
                      color: '#017efc',
                    }}
                  >
                    Canvas Settings
                  </header>
                  <label style={{ marginRight: '20px' }}>Canvas Size</label>
                  <label style={{ marginRight: '8px' }}>Width</label>
                  <InputNumber
                    style={{ width: '4vw' }}
                    size='small'
                    min={1}
                    max={100000}
                    defaultValue={1920}
                    controls={false}
                  />
                  <label style={{ marginRight: '8px', marginLeft: '1.6vw' }}>
                    Height
                  </label>
                  <InputNumber
                    style={{ width: '4vw' }}
                    size='small'
                    min={1}
                    max={100000}
                    controls={false}
                    defaultValue={1080}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Canvas Position</label>
                  <InputNumber
                    style={{ width: '5vw' }}
                    size='small'
                    min={1}
                    max={100000}
                    defaultValue={244}
                    controls={false}
                  />
                  <InputNumber
                    style={{ width: '5vw', marginLeft: '40px' }}
                    size='small'
                    min={1}
                    max={100000}
                    controls={false}
                    defaultValue={180}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Page Scaling</label>
                  <Select
                    defaultValue='Proportional'
                    style={{
                      width: '11.6vw',
                      color: '#fff',
                      background: '#262c33',
                    }}
                    size='small'
                    allowClear
                  >
                    <Option value='Proportional'>Proportional Scaling</Option>
                    <Option value='Width'>Width Scaling</Option>
                    <Option value='Height'>Height Scaling</Option>
                  </Select>
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Background Color</label>
                  <Input
                    style={{
                      width: '11.6vw',
                      background: '#262c33',
                      color: '#fff',
                    }}
                    size='small'
                    placeholder='Enter hex color code'
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Opacity</label>
                  <Slider
                    min={1}
                    max={100}
                    style={{ width: '15vw' }}
                    defaultValue={80}
                  />
                </li>
                <li>
                  <header
                    style={{
                      marginRight: '20px',
                      marginBottom: '20px',
                      color: '#017efc',
                    }}
                  >
                    Satellite Parameter Settings
                  </header>
                  <label style={{ marginRight: '20px' }}>Show Satellite Icons</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.icon?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            icon: { val: val, name: 'Satellite Icon' },
                            currEdit: { val: val, name: 'icon' },
                          },
                        };
                      });
                    }}
                  />
                  <label style={{ marginLeft: '20px', marginRight: '20px' }}>
                    Upload Satellite Icon
                  </label>
                  <Upload>
                    <Button
                      size='small'
                      style={{ background: '#262c33', color: '#fff' }}
                      icon={<UploadOutlined />}
                    >
                      Click to Upload
                    </Button>
                  </Upload>
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Satellite Track</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.track?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            track: { val: val, name: 'Satellite Track' },
                            currEdit: { val: val, name: 'track' },
                          },
                        };
                      });
                    }}
                  />
                  <label style={{ marginLeft: '20px', marginRight: '20px' }}>
                    Upload Satellite Data
                  </label>
                  <Upload>
                    <Button
                      size='small'
                      style={{ background: '#262c33', color: '#fff' }}
                      icon={<UploadOutlined />}
                    >
                      Click to Upload
                    </Button>
                  </Upload>
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Satellite Name</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.label?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            label: { val: val, name: 'Satellite Label' },
                            currEdit: { val: val, name: 'label' },
                          },
                        };
                      });
                    }}
                  />
                </li>
              </ul>
              <p
                style={{
                  fontSize: '16px',
                  color: '#017efc',
                  borderBottom: '2px solid #017efc',
                }}
              >
                System Settings
              </p>
              <ul className='settingList'>
                <li>
                  <header
                    style={{
                      marginRight: '20px',
                      marginBottom: '20px',
                      color: '#017efc',
                    }}
                  >
                    Scene Settings
                  </header>
                  <label style={{ marginRight: '20px' }}>Scene Name</label>
                  <Input
                    style={{
                      width: '11.6vw',
                      background: '#262c33',
                      color: '#fff',
                    }}
                    size='small'
                    onChange={(e) => {
                      sceneNameRef.current = e.target.value;
                    }}
                    placeholder='Enter scene name'
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Earth Rotation</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.rotate?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            rotate: { val: val, name: 'Earth Rotation' },
                            currEdit: { val: val, name: 'rotate' },
                          },
                        };
                      });
                    }}
                  />
                  <label style={{ marginLeft: '20px', marginRight: '10px' }}>
                    Rotation Speed
                  </label>
                  <Slider
                    min={1}
                    max={50}
                    style={{
                      width: '10vw',
                      float: 'right',
                      marginRight: '25%',
                    }}
                    defaultValue={20}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Lighting</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.light?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            light: { val: val, name: 'Show Lighting' },
                            currEdit: { val: val, name: 'light' },
                          },
                        };
                      });
                    }}
                  />
                  <label style={{ marginLeft: '20px', marginRight: '10px' }}>
                    Lighting Intensity
                  </label>
                  <Slider
                    min={1}
                    max={10}
                    style={{
                      width: '10vw',
                      float: 'right',
                      marginRight: '25%',
                    }}
                    defaultValue={5}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Sun</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.sun?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            sun: { val: val, name: 'Show Sun' },
                            currEdit: { val: val, name: 'sun' },
                          },
                        };
                      });
                    }}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Starfield</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.star?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            star: { val: val, name: 'Show Starfield' },
                            currEdit: { val: val, name: 'star' },
                          },
                        };
                      });
                    }}
                  />
                </li>
                <li>
                  <label style={{ marginRight: '20px' }}>Show Timeline</label>
                  <Switch
                    checkedChildren='On'
                    unCheckedChildren='Off'
                    defaultChecked={setting.time?.val}
                    onChange={(val, e) => {
                      setSetting((prev) => {
                        return {
                          ...prev,
                          ...{
                            time: { val: val, name: 'Show Timeline' },
                            currEdit: { val: val, name: 'time' },
                          },
                        };
                      });
                    }}
                  />
                </li>
              </ul>
              <Button
                type='primary'
                style={{ width: '8vw', marginLeft: '10vw', marginTop: '2vh' }}
                shape='round'
                size='large'
                onClick={() => {
                  if(sceneNameRef.current == ""){
                    openNotification('Please enter a scene name!');
                  }else{
                    let nowUseSatelliteList = []
                    for(let i of satelliteList){
                      nowUseSatelliteList.push([...i])
                    }
                    let scene = {
                      satelliteList: [...nowUseSatelliteList],
                      setting: setting,
                      sceneName: sceneNameRef.current
                    }
                    console.log(scene)
                    //@ts-ignore
                    setScanes((prev)=>{
                      return [...prev, ...[scene]]
                    });
                    openNotification('Scene added successfully!');
                  }
                }}
              >
                Save Scene
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SettingPanel;
